// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-6ee13be0],td[data-v-6ee13be0],th[data-v-6ee13be0]{border:.5px solid #000;padding:6px}.blanco[data-v-6ee13be0]{border:1px solid #fff!important;padding:6px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
